// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-devices-selector[data-v-3cca9784]{margin-top:28px;margin-bottom:8px}.media-devices-selector__heading[data-v-3cca9784]{font-weight:bold}.media-devices-selector .multiselect[data-v-3cca9784]{width:100%}\n", ""]);
// Exports
module.exports = exports;
